import { css } from 'linaria';
import { styled } from 'linaria/react';

export const manualsOuterWrap = css`
  display: flex;
  margin: var(--space-500) 0 0;
  width: inherit;

  @media (--only-mobile) {
    margin: var(--space-200) 0 0;
  }
`;

export const manualsInnerWrap = css`
  display: flex;
  gap: var(--space-400);
  overflow-x: auto;
  min-height: var(--space-1000);

  @media (--only-mobile) {
    margin: 0 var(--space-200);
  }
`;

export const manualWrap = css`
  display: flex;
  max-height: var(--space-500);
  gap: var(--space-100);

  &:hover {
    & > div {
      & > span {
        color: var(--text-dark) !important;
        transition: color 0.2s ease-out;
      }
    }
  }
`;

export const textWrap = css`
  display: flex;
  flex-direction: column;
  margin: var(--space-25) 0;
`;

export const labelLinkButtonStyle = css`
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const sizeLinkButtonStyle = css`
  display: block;
`;

export const EmptyBlock = styled.div`
  padding-top: var(--space-250);
  padding-bottom: var(--space-250);
`;
